import { motion } from 'framer-motion';
import { LegacyRef, useState } from 'react';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { FaTrashCan } from 'react-icons/fa6';
import { MdCancelPresentation, MdLibraryAddCheck } from 'react-icons/md';
import { RiEditFill } from 'react-icons/ri';
import { useAuthContext } from '../../contexts/AuthProvider';
import { useVacationRequestContext } from '../../contexts/VacationRequestProvider';
import useUserClickObserver from '../../hooks/useUserClickObserver';
import { User } from '../../types/users';
import { VacationRequest } from '../../types/vacations';
import ActionButton from '../CommonComps/Buttons/ActionButton';

const VacationRequestUpdateActions = ({
  request,
}: {
  request: VacationRequest;
}) => {
  // integration of react hooks here
  const [showMenu, setShowMenu] = useState<boolean>(false);

  // integration of context hooks here
  const {
    setShowUpdateModal,
    setVacationRequest,
    setShowDeleteModal,
    setShowApproveModal,
    setShowRejectModal,
  } = useVacationRequestContext();

  const { currentUser } = useAuthContext();

  // integration of custom hooks here
  const selectRef = useUserClickObserver(setShowMenu);

  // handler function to show modal on button click declared here
  const showModalHandler = (
    modalName: 'update' | 'delete' | 'approve' | 'reject'
  ) => {
    switch (modalName) {
      case 'update':
        setShowUpdateModal(true);
        setVacationRequest(request);
        break;

      case 'delete':
        setShowDeleteModal(true);
        setVacationRequest(request);
        break;

      case 'approve':
        setShowApproveModal(true);
        setVacationRequest(request);
        break;

      case 'reject':
        setShowRejectModal(true);
        setVacationRequest(request);
        break;

      default:
        break;
    }

    setShowMenu(false);
  };

  // rendering vacation request update action component here
  return (
    <div ref={selectRef as LegacyRef<HTMLDivElement>} className='relative'>
      <div className='flex items-center justify-center'>
        <button
          onClick={() => setShowMenu((state) => !state)}
          className='hover:opacity-40 active:scale-90 duration-300'
        >
          <BsThreeDotsVertical className='size-6' />
        </button>
      </div>

      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={
          showMenu
            ? { height: 'fit-content', opacity: 1 }
            : { height: 0, opacity: 0 }
        }
        className='absolute bottom-1/2 right-0 bg-base-white shadow-academia-sm rounded-lg overflow-hidden '
      >
        <div className='max-h-[100px] overflow-y-auto academia-scrollbar'>
          <ActionButton
            onClick={() => showModalHandler('update')}
            colorClass='text-base-cyan'
            isDisabled={request.is_approved || request.is_rejected}
          >
            <RiEditFill />
            <span>Update Request</span>
          </ActionButton>

          <ActionButton
            onClick={() => showModalHandler('delete')}
            colorClass='text-base-red'
          >
            <FaTrashCan />
            <span>Delete Request</span>
          </ActionButton>

          {(currentUser as User)?.role_name === 'Admin' ? (
            <>
              <ActionButton
                onClick={() => showModalHandler('approve')}
                colorClass='text-base-cyan'
                isDisabled={request.is_approved}
              >
                <MdLibraryAddCheck />
                <span>Approve Request</span>
              </ActionButton>

              <ActionButton
                onClick={() => showModalHandler('reject')}
                colorClass='text-base-red'
                isDisabled={request.is_rejected}
              >
                <MdCancelPresentation />
                <span>Reject Request</span>
              </ActionButton>
            </>
          ) : null}
        </div>
      </motion.div>
    </div>
  );
};

export default VacationRequestUpdateActions;
